const DedicatedTruck = {
  validHeader: {
    Source: 'source',
    'Depot Ref ID': 'depot_ref_id',
    'Transporter Ref ID': 'transporter_ref_id',
    'Vehicle Name': 'vehicle_type',
    'Minimum Guarantee Freight Cost': 'minimum_guarantee_amount',
    'No of Trips': 'no_of_trips',
    'Additional km Charge': 'per_km_rate',
    'BFR Label': 'bfr_label',
    'Guarantee KM': 'guarantee_km',
  },
  optionalHeader: {},
  validationLabel: {
    MINIMUM_GUARANTEE_AMOUNT: 'Minimum guarantee amount',
    NO_OF_TRIPS: 'Number of trips',
    PER_KM_RATE: 'Per Km rate',
  },
  errorLabels: {
    INVALID_DEPOT_ID: 'Invalid Depot Ref ID',
    INVALID_TRANSPORTER_ID: 'Invalid Transporter Ref ID',
    INVALID_VEHICLE_NAME: 'Invalid Vehicle Name',
  },
};
module.exports = { DedicatedTruck };
